// Project 3: Mock usage/cost tracking for frontend-only phase
import type { RateLimitInfo, UsageRecord } from '@/types/usage';

const STORAGE_KEY = 'keyword222_usage_records';

function readAll(): UsageRecord[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as UsageRecord[]) : [];
  } catch {
    return [];
  }
}

function writeAll(records: UsageRecord[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
  } catch {
    // ignore
  }
}

export class UsageService {
  async record(record: Partial<UsageRecord> & { userId: number; costUsd: number }): Promise<void> {
    const all = readAll();
    const fullRecord: UsageRecord = {
      id: record.id || `usage_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      userId: record.userId,
      action: record.action || (record.actionType?.includes('blog') ? 'blog' : 'youtube_script'),
      actionType: record.actionType,
      tokensIn: record.tokensIn || 0,
      tokensOut: record.tokensOut || 0,
      costUsd: record.costUsd,
      createdAtISO: record.createdAtISO || record.timestamp || new Date().toISOString(),
      timestamp: record.timestamp || record.createdAtISO,
    };
    all.unshift(fullRecord);
    writeAll(all.slice(0, 200)); // cap to 200
  }

  async list(): Promise<UsageRecord[]> {
    return readAll();
  }

  async getRateLimit(userId: number): Promise<RateLimitInfo> {
    const all = readAll().filter((r) => r.userId === userId);
    const limit = 100; // mock premium-like limit
    const used = all.length;
    const remaining = Math.max(0, limit - used);
    const reset = new Date();
    reset.setHours(24, 0, 0, 0);
    return {
      limit,
      used,
      remaining,
      resetAtISO: reset.toISOString(),
    };
  }
}

export const usageService = new UsageService();


